import { ConstraintDto, ModelBase, MoveCommand, Point } from "pytha";
import { Vector3 } from "three";
import { PYTHA_SINGAL } from "../enums/pytha-signal";




export class MonixMoveCommand extends MoveCommand {


    dcArr: ModelBase[] = [];
    relatedLeftDcaligned = [];
    relatedRightDcaligned = [];

    constructor(entities: ModelBase[], dir: Vector3, dist: number, relatedLines?: ConstraintDto[], isSubClass: boolean = false) {
        super(entities, dir, dist, relatedLines, isSubClass);
    }

    execute = () => {
        this.dcArr = [];
        let girdArr = [];
        for (let entity of this.entities) {
            entity.move(this.dir, this.dist);
            entity.getBoundingBox();
            entity.needRedraw = true;
            this.pushOrUpdateEle(entity);
        }
        this.entities = [...this.entities, ...girdArr];
        this.editor.listeners.signals.needRender.dispatch('redraw');
        let filterList = this.entities.filter(entity => entity.positionUpdateCallBack);
        this.editor.listeners.getSignal(PYTHA_SINGAL.onEntitiesMovePosition).dispatch(filterList);
        this.extraContext.apiContext.createPrimitiveMulti(this.cstParArr.map((entity: ModelBase) => {
            if (entity.toJson) {
                return entity.toJson();
            }
            return null
        }));
    }

    undo(): void {
        this.dcArr = [];
        for (let entity of this.entities) {
            entity.move(this.dir, - this.dist);
            entity.getBoundingBox();
            entity.needRedraw = true;
            this.pushOrUpdateEle(entity);
        }

        this.editor.listeners.signals.needRender.dispatch('redraw');
        let filterList = this.entities.filter(entity => entity.positionUpdateCallBack);
        this.editor.listeners.getSignal(PYTHA_SINGAL.onEntitiesMovePosition).dispatch(filterList);
        this.extraContext.apiContext.createPrimitiveMulti(this.cstParArr.map((entity: ModelBase) => {
            if (entity.toJson) {
                return entity.toJson();
            }
            return null
        }));
    }

    pushOrUpdateEle = (entity: ModelBase) => {
        const index = this.cstParArr.findIndex(element => element.uuid === entity.uuid);

        if (index !== -1) {
            // 如果找到相同 uuid 的对象，替换旧的
            this.cstParArr.splice(index, 1, entity);
        } else {
            // 否则进行尾插
            this.cstParArr.push(entity);
        }
    }

    pushNotExistDc = (entity: ModelBase) => {
        if (!this.dcArr.some(i => i.uuid === entity.uuid)) {
            this.dcArr.push(entity);
        }
    }
}